
<div id="app" class="d-flex flex-column vh-100">
  <NavBar />
  <Body class="flex-fill overflow-auto" />
  <NavFooter />
</div>
